import SearchSelectPatient from "../Patients/SearchSelectPatient";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../Context/AuthProvider";
import { showLoadingImage, showSmallLoadingImage } from "../Utility/Utility";
import {
  getClinicalServices,
  getPrimaryClinicalServices,
} from "../API/FacilitySettingsApi";
import { convertToUTC, getDatesArray } from "../Utility/DateTimeUtility";
import ManualSlotBooking from "./ManualSlotBooking";
import {
  Button,
  Card,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from "@mui/material";

import { getFacilityUsers } from "../API/UsersApi";
import { createNewVisit } from "../API/VisitsApi";
import SlotSelector from "./SlotSelector";

function NewAppointment1({ newAppointmentTempId, visitType }) {
  const [errorMessage, setErrorMessage] = useState();
  const [selectedPatient, setSelectedPatient] = useState();
  const [availablePhysicians, setAvailablePhysicians] = useState();
  const { auth } = useContext(AuthContext);
  const [patientNotes, setPatientNotes] = useState();
  const [availableServices, setAvailableServices] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState("");
  const [selectedPhysicianId, setSelectedPhysicianId] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedPhysician, setSelectedPhysician] = useState("");
  const [selectedVisitType, setSelectedVisitType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [scheduledFrom, setScheduledFrom] = useState("");
  const [scheduledTo, setScheduledTo] = useState("");
  const [travelTime, setTravelTime] = useState("");
  // const [selectedVisitType, setSelectedVisitType] = useState(visitType);
  const noOfDaysToShowSlots = 7;
  const [dateRange, setDateRange] = useState(
    getDatesArray(new Date(), noOfDaysToShowSlots)
  );
  const [addingAppointment, setAddingAppointment] = useState(false);
  const [isWalkIn, setIsWalkIn] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [dataRestored, setDataRestored] = useState(false);
  const [isWalkInAllowed, setIsWalkInAllowed] = useState(false);

  useEffect(() => {
    const getPhysicians = async () => {
      var result = await getFacilityUsers(auth, {
        facilityId: auth.selectedFacility.id,
        roles: ["Physician"],
      });
      if (result?.isSuccess) {
        setAvailablePhysicians(result?.data);
      }
    };

    const setClinicalServices = async () => {
      const filters = {
        facilityId: auth.selectedFacility.id,
        visitType: visitType,
      };
      var result = await getClinicalServices(auth, filters);
      if (result.isSuccess) {
        console.log(result?.data);
        setAvailableServices(result?.data);
      } else {
        setErrorMessage(result.data);
      }
    };

    const restoreData = () => {
      const savedNewVisit = localStorage.getItem(newAppointmentTempId);

      if (savedNewVisit) {
        const savedNewVisitJSON = JSON.parse(savedNewVisit);
        if (savedNewVisitJSON) {
          setSelectedPatient(savedNewVisitJSON.selectedPatient);
          setSelectedPhysicianId(savedNewVisitJSON.selectedPhysicianId);
          setSelectedServiceId(savedNewVisitJSON.selectedServiceId);
          setSelectedTimeSlot(savedNewVisitJSON.selectedTimeSlot);
          setPatientNotes(savedNewVisitJSON.patientNotes);
          setIsWalkIn(savedNewVisitJSON.isWalkIn);
          setActiveStep(savedNewVisitJSON.activeStep);
        }
      }
      setDataRestored(true);
    };

    setDataRestored(false);
    setClinicalServices();
    getPhysicians();
    restoreData();
  }, [auth, newAppointmentTempId]);

  useEffect(() => {
    if (dataRestored) {
      const savedNewVisit = localStorage.getItem(newAppointmentTempId);
      const savedNewVisitJSON = savedNewVisit ? JSON.parse(savedNewVisit) : {};

      savedNewVisitJSON.selectedPatient = selectedPatient;
      savedNewVisitJSON.selectedPhysicianId = selectedPhysicianId;
      savedNewVisitJSON.selectedServiceId = selectedServiceId;
      savedNewVisitJSON.selectedTimeSlot = selectedTimeSlot;
      savedNewVisitJSON.patientNotes = patientNotes;
      savedNewVisitJSON.isWalkIn = isWalkIn;
      savedNewVisitJSON.selectedVisitType = visitType;
      savedNewVisitJSON.activeStep = activeStep;
      localStorage.setItem(
        newAppointmentTempId,
        JSON.stringify(savedNewVisitJSON)
      );
    }
  }, [
    newAppointmentTempId,
    selectedPatient,
    selectedPhysicianId,
    selectedServiceId,
    selectedTimeSlot,
    patientNotes,
    isWalkIn,
    activeStep,
    dataRestored,
  ]);

  const addAppointment = async () => {
    setAddingAppointment(true);
    //e.preventDefault();
    // const physicianId = document.querySelector("#physicianSelector").value;
    // const serviceId = document.querySelector("#serviceSelector").value;
    const result = await createNewVisit(
      auth,
      selectedPatient.id,
      selectedPhysicianId,
      convertToUTC(selectedTimeSlot),
      patientNotes,
      isWalkIn,
      visitType,
      selectedServiceId
    );
    if (result.isSuccess) {
      setSuccessMessage("Visit created successfully.");
      //showAppointments();
    } else {
      setErrorMessage("Error occurred while creating the visit.");
    }
    setAddingAppointment(false);
  };

  const renderServiceAndPhysicianSelectors = () => {
    return (
      <Card
        variant="outlined"
        spacing={2}
        sx={{ height: "400px", padding: "10px" }}
      >
        <Grid2 container size={12} spacing={2}>
          <Grid2 container size={12}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Primary Service
              </InputLabel>
              <Select
                label="Primary Service"
                value={selectedServiceId}
                disabled={addingAppointment}
                onChange={(e) => {
                  setSelectedServiceId(e.target.value);
                  setSelectedService(
                    availableServices.find((s) => s.id === e.target.value)
                  );
                }}
              >
                {availableServices &&
                  availableServices?.map((s) => (
                    <MenuItem value={s.id}>
                      {s.name}, Fees Rs. {s.fees}, Duration {s.durationInMins}{" "}
                      Mins
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 container size={12}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Physician</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedPhysicianId}
                label="Physician"
                disabled={addingAppointment}
                onChange={(e) => {
                  setSelectedPhysicianId(e.target.value);
                  setSelectedPhysician(
                    availablePhysicians.find((p) => p.id === e.target.value)
                  );
                }}
              >
                {availablePhysicians &&
                  availablePhysicians?.map((p) => (
                    <MenuItem value={p.id}>
                      {p.salutation} {p.firstName} {p.lastName}, {p.suffix}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid2>

          <Grid2 container size={12}>
            <TextField
              fullWidth
              label="Notes"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={patientNotes}
              multiline
              minRows={3}
              maxRows={3}
              disabled={addingAppointment}
              onChange={(e) => {
                setPatientNotes(e.target.value);
              }}
            ></TextField>
          </Grid2>
        </Grid2>
      </Card>
    );
  };

  const renderAvailableSlots = () => {
    return visitType === "Home" ? (
      <ManualSlotBooking />
    ) : (
      <SlotSelector
        isWalkInAllowed={isWalkInAllowed}
        isWalkIn={isWalkIn}
        setIsWalkIn={setIsWalkIn}
        selectedService={selectedService}
        selectedPhysicianId={selectedPhysicianId}
        selectedServiceId={selectedServiceId}
        selectedTimeSlot={selectedTimeSlot}
        setSelectedTimeSlot={setSelectedTimeSlot}
        dateRange={dateRange}
        setDateRange={setDateRange}
      />
    );
  };

  const renderVisitSummary = () => {
    return (
      <Card
        variant="outlined"
        spacing={2}
        sx={{ height: "auto", padding: "10px" }}
      >
        <Grid2 size={12} sx={{ marginLeft: "10px" }}>
          <Typography variant="h6">
            Please verify the details before saving.
          </Typography>

          {/* Patient Details */}
          <Typography sx={{ mt: 2 }} variant="body1">
            Selected Patient:
          </Typography>
          <Typography sx={{ mt: 1 }} variant="body2">
            {selectedPatient?.prefix} {selectedPatient?.firstName}{" "}
            {selectedPatient?.lastName},{selectedPatient?.gender},{" "}
            {selectedPatient?.ageInYears} Years, Mobile:{" "}
            {selectedPatient?.mobileNo}
          </Typography>

          {/* Primary Service */}
          <Typography sx={{ mt: 2 }}>Selected Primary Service:</Typography>
          <Typography sx={{ mt: 1 }} variant="body2">
            {selectedService?.name
              ? `${selectedService.name}, Fees: Rs. ${selectedService.fees}, Duration: ${selectedService.durationInMins} Mins`
              : "N/A"}
          </Typography>

          {/* Selected Physician */}
          <Typography sx={{ mt: 2 }}>Selected Physician:</Typography>
          <Typography sx={{ mt: 1 }} variant="body2">
            {selectedPhysician?.salutation} {selectedPhysician?.firstName}{" "}
            {selectedPhysician?.lastName}, {selectedPhysician?.suffix || ""}
          </Typography>

          {/* Booking Type */}
          <Typography sx={{ mt: 2 }}>Booking Type:</Typography>
          <Typography sx={{ mt: 1 }} variant="body2">
            {isWalkIn ? "Walk-In" : "Scheduled"} &nbsp;
            {!isWalkIn && selectedTimeSlot
              ? new Date(selectedTimeSlot).toLocaleString("en-US", {
                  weekday: "short",
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : ""}
          </Typography>

          {/* Visit Type */}
          <Typography sx={{ mt: 2 }}>Visit Type:</Typography>
          <Typography sx={{ mt: 1 }} variant="body2">
            {selectedVisitType || "N/A"}
          </Typography>

          {/* Home Visit Details */}
          {selectedVisitType === "Home" && (
            <>
              <Typography sx={{ mt: 2 }}>Scheduled Date:</Typography>
              <Typography sx={{ mt: 1 }} variant="body2">
                {selectedDate || "N/A"}
              </Typography>

              <Typography sx={{ mt: 2 }}>Scheduled Time:</Typography>
              <Typography sx={{ mt: 1 }} variant="body2">
                {scheduledFrom && scheduledTo
                  ? `${scheduledFrom} - ${scheduledTo}`
                  : "N/A"}
              </Typography>

              <Typography sx={{ mt: 2 }}>Travel Time:</Typography>
              <Typography sx={{ mt: 1 }} variant="body2">
                {travelTime ? `${travelTime} mins` : "N/A"}
              </Typography>
            </>
          )}
        </Grid2>
      </Card>
    );
  };

  const renderFinalMessage = () => {
    return (
      <Card
        variant="outlined"
        spacing={2}
        sx={{ height: "400px", padding: "10px" }}
      >
        <Grid2 size={12} sx={{ height: "400px", marginLeft: "10px" }}>
          {successMessage && (
            <Fragment>
              <Typography variant="h6">{successMessage}</Typography>
              <Typography variant="h6">Please close this tab.</Typography>
            </Fragment>
          )}
          {errorMessage && (
            <Fragment>
              <Typography variant="h6">{errorMessage}</Typography>
              <Typography variant="h6">
                Please close this tab now and try again later. If the problem
                persists, please contact the user support.
              </Typography>
            </Fragment>
          )}
        </Grid2>
      </Card>
    );
  };

  //Stepper code
  const steps = [
    "Select a Patient",
    "Select Physician and Service",
    "Select Timeslot",
    "Create a Visit",
  ];

  const handleNext = async () => {
    if (activeStep === 1) {
      //showSlotsForDefaultDateRange();
      setDateRange(getDatesArray(new Date(), noOfDaysToShowSlots));
    }
    if (activeStep === 3) {
      await addAppointment();
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 1) {
      setSelectedPatient();
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Grid2 size={6} container sx={{ padding: "25px" }}>
      <Grid2 size={12}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Grid2>
      <Grid2 size={12}>
        <Fragment>
          <Grid2 container sx={{ height: "500px" }}>
            <Grid2 size={{ lg: 1, xl: 2 }}></Grid2>
            <Grid2 size={{ lg: 10, xl: 8 }} sx={{ paddingTop: "50px" }}>
              {activeStep === 0 && (
                <SearchSelectPatient setSelectedPatient={setSelectedPatient} />
              )}
              {activeStep === 1 && renderServiceAndPhysicianSelectors()}
              {activeStep === 2 && renderAvailableSlots()}
              {activeStep === 3 && renderVisitSummary()}
              {activeStep === 4 && renderFinalMessage()}
            </Grid2>
            <Grid2 size={{ lg: 1, xl: 2 }}></Grid2>
          </Grid2>

          <Grid2 container spacing={1} sx={{ justifyContent: "center" }}>
            <Button
              variant="outlined"
              color="inherit"
              disabled={activeStep === 0}
              hidden={activeStep === 4}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Button
              onClick={handleNext}
              variant="contained"
              color="secondary"
              hidden={activeStep === 4}
              disabled={
                (activeStep === 0 && !selectedPatient) ||
                (activeStep === 1 &&
                  (!selectedServiceId || !selectedPhysicianId)) ||
                (activeStep === 2 &&
                  selectedVisitType === "Home" &&
                  (!selectedDate ||
                    !scheduledFrom ||
                    !scheduledTo ||
                    !travelTime))
              }
            >
              {activeStep === steps.length - 1 && addingAppointment ? (
                showSmallLoadingImage()
              ) : (
                <></>
              )}
              {activeStep === steps.length - 1 ? "Save Visit" : "Next"}
            </Button>
          </Grid2>
        </Fragment>
      </Grid2>
    </Grid2>
  );
}
export default NewAppointment1;
